module.exports = __webpack_public_path__ + "img/car.992fffbd.png";